import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const LibraryLayout = ({ children }) => {
    return <Container>{children}</Container>;
};

LibraryLayout.propTypes = {
    children: PropTypes.node.isRequired
};

export default LibraryLayout;
